export const SOURCE_LOGOUT = 'logout';
export const SOURCE_PVS = 'post-visit summary';

export const TRACKING_LOAD_MARY_MAGIC_SURVEY = 'LOAD_MARY_MAGIC_SURVEY';
export const MARY_MAGIC_SURVEY_EVENT = 'Mary Magic Survey';
